// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__1zeWM","MainCenter":"Main_MainCenter__2E5pX","P":"Main_P__1zcjC","Li":"Main_Li__1OePL","H2":"Main_H2__2X4Te"};